import React from 'react';
import { Collapse, Space, Tag, Typography } from 'antd';

const { Text, Paragraph } = Typography;

interface SearchTermsSuggestionProps {
    terms: string[];
}

export const SearchTermsSuggestion: React.FC<SearchTermsSuggestionProps> = ({ terms }) => {
    if (terms.length === 0) return null;

    return (
        <Collapse
            size="small"
            items={[{
                key: 'search',
                label: (
                    <Space>
                        <span>🔍 后台搜索词建议</span>
                        <Tag color="blue">{terms.length} 个</Tag>
                    </Space>
                ),
                children: (
                    <div>
                        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
                            以下关键词未在文案中出现，建议添加到"Backend Search Terms"中:
                        </Paragraph>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            {terms.map((term, idx) => (
                                <Tag key={idx}>{term}</Tag>
                            ))}
                        </div>
                        <Paragraph
                            copyable={{ text: terms.join(' ') }}
                            style={{ marginTop: 8, marginBottom: 0 }}
                        >
                            <Text type="secondary">点击复制全部</Text>
                        </Paragraph>
                    </div>
                ),
            }]}
        />
    );
};
